import React, { useState, useEffect, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { timesheetApi, Util } from "../../services";
import { Button } from "primereact/button";
import { Fieldset } from "primereact/fieldset";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import RejectTimesheetPopup from "./dialogBox/rejectTimesheetPopup";
import { confirmDialog } from "primereact/confirmdialog";
import moment from "moment";

const ReviewTeamTimesheet = ({ userData }) => {
  const dt = useRef(null);
  const [rejectRowData, setRejectRowData] = useState({});
  const [rejectedType, setRejectedType] = useState("");
  const [rejectDialog, setRejectDialog] = useState(false);
  const [empReviewTimesheetList, setEmpReviewTimesheetList] = useState([]);
  const [timesheetCtreatedUserId, setTimesheetCtreatedUserId] = useState("");
  const [currentReviewRow, setCurrentReviewRow] = useState({});
  const [reviewTimesheetDialog, setReviewTimesheetDialog] = useState(false);
  const [viewAllTimesheetDialog, setViewAllTimesheetDialog] = useState(false);
  const [viewAllTimesheet, setViewAllTimesheet] = useState([]);
  const [empReviewTimesheetDisabled, setEmpReviewTimesheetDisabled] = useState(true);

  const [imapctBillableDialog, setImapctBillableDialog] = useState(false);
  const [selectedTimesheetIds, setSelectedTimesheetIds] = useState([]);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchEmpReviewTimesheet();
      count++;
    }
  }, [userData]);

  const fetchEmpReviewTimesheet = () => {
    timesheetApi.getReviewimesheetsData(userData?.id).then((resp) => {
      try {
        if (resp?.data?.data?.length > 0) {
          setEmpReviewTimesheetDisabled(false);
        }
        setEmpReviewTimesheetList(resp?.data?.data);
        setTimesheetCtreatedUserId(userData?.id)
      } catch (error) {
        // Error handle
      }
    });
  };

  /* Dialog Box for Reject timesheet Start */
  const rejectReviewTeamTimesheetData = (rowData, type) => {
    setRejectRowData(rowData);
    setRejectDialog(true);
    setRejectedType(type);
  }

  const RejectReviewTimesheetDialog = () => {
    return (
      <Dialog className="pop-up-dialog-recall" header="Reject Timesheet" visible={rejectDialog} style={{ width: '380px' }} onHide={() => setRejectDialog(false)}>
        <RejectTimesheetPopup
          updateRejectRow={(data) => rejectTimesheetData(data)}
          rejectRow={rejectRowData}
          onClose={(e) => {
            setRejectDialog(false);
          }}
        />
      </Dialog>
    );
  };

  const rejectTimesheetData = (data) => {
    let statusType = "REJECT";
    var dataObj = [];

    if (rejectedType === 1) {
      let ObjData = {
        reason: data.reason,
        status: statusType,
        userId: timesheetCtreatedUserId,
        timesheet: [rejectRowData.id],
      };
      dataObj.push(ObjData);
    }
    if (rejectedType === 2) {
      let approvedEmpId = empReviewTimesheetList.map((a) => a.id);
      let ObjData = {
        reason: data.reason,
        status: statusType,
        userId: timesheetCtreatedUserId,
        timesheet: approvedEmpId,
      };
      dataObj.push(ObjData);
    }
    try {
      timesheetApi.approveRejectBulkTimesheet(dataObj).then(
        (resp) => {
          fetchEmpReviewTimesheet(userData?.id);
          toast.success(
            userData?.name + " Timesheet has been rejected..."
          );
        },
        (err) => {
          toast.error("Unable to reject timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to reject timesheet...");
    }
  };
  /* Dialog Box for Reject timesheet End */

  /* Approved Review Timesheet Data Start */
  const handleCheckboxChange = (e, timesheetId) => {
    if (e.target.checked) {
      setSelectedTimesheetIds(prev => [...prev, timesheetId]);
    } else {
      setSelectedTimesheetIds(prev => prev.filter(id => id !== timesheetId));
    }
  };

  const updateBillableActivity = (dataObj, type) => {
    let statusType = "APPROVED";
    if (type === 1) {
      dataObj = dataObj;
    }
    if (type === 2) {
      let approvedEmpId = empReviewTimesheetList.map((a) => a.id);
      let ObjData = [{
        reason: statusType,
        status: statusType,
        userId: timesheetCtreatedUserId,
        timesheet: approvedEmpId,
        billableTimesheet: selectedTimesheetIds,
      }];
      dataObj = ObjData;
    }
    try {
      console.log(dataObj, "dataObjdataObj")
      setSelectedTimesheetIds([]);
      timesheetApi.approveRejectBulkTimesheet(dataObj).then(
        (resp) => {
          setImapctBillableDialog(false);
          setEmpReviewTimesheetList([]);
          fetchEmpReviewTimesheet();
          toast.success(
            userData?.name + " Timesheet has been approved..."
          );
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to approve timesheet");
    }

  }

  const BillableImpactDialog = () => {
    const lhEntries = empReviewTimesheetList?.filter(timesheet =>
      timesheet?.timesheetProjects.some(detail => detail?.categories?.code === "LH")
    ).map(ts => ({
      date: ts.date,
      id: ts.id
    }));
    return (
      <Dialog className="pop-up-dialog-recall" header="Billable Impact Timesheet" visible={imapctBillableDialog} style={{ width: '700px' }} onHide={() => setImapctBillableDialog(false)}>
        <div className="missing-attendance-dates">
          <ul>
            {lhEntries?.map((e) => (
              <li key={e.id} className={"D-" + moment(e?.date, "DD-MM-YYYY").format("ddd")}>
                <label>
                  <input
                    type="checkbox"
                    onChange={(event) => handleCheckboxChange(event, e.id)}
                    checked={selectedTimesheetIds.includes(e.id)}
                  />
                  <span>{moment(e?.date, "DD-MM-YYYY").format("ddd DD-MM-YYYY")}</span>
                </label>
              </li>
            ))}
          </ul>
          <span>If you want to make as billable activity on above leaves, please select them and submit!</span>
          <Button className="ml-4" label="Submit" onClick={() => updateBillableActivity("", 2)}></Button>
        </div>
      </Dialog>
    );
  };


  const approveReviewTeamTimesheetData = (rowData, type) => {
    let statusType = "APPROVED";
    var dataObj = [];
    if (type === 1) {
      const lhEntries = rowData?.timesheetProjects?.filter(timesheet => timesheet?.categories?.code === "LH").map(ts => ({
        date: ts.date,
        id: ts.timesheetId
      }));

      if (lhEntries?.length > 0) {
        confirmDialog({
          // target: e.currentTarget,
          message: 'Are you want to make as billable this leave record?',
          header: 'Leave Billable Confirmation',
          icon: 'pi pi-info-circle',
          acceptClassName: "p-button-danger",
          acceptLabel: 'No',
          rejectLabel: 'Yes',
          reject: () => {
            let ObjData = {
              reason: statusType,
              status: statusType,
              userId: timesheetCtreatedUserId,
              timesheet: [rowData.id],
              billableTimesheet: [lhEntries[0]?.id],
            };
            dataObj.push(ObjData);
            updateBillableActivity(dataObj, type);
          },
          accept: () => {
            let ObjData = {
              reason: statusType,
              status: statusType,
              userId: timesheetCtreatedUserId,
              timesheet: [rowData.id],
              billableTimesheet: [],
            };
            dataObj.push(ObjData);
            updateBillableActivity(dataObj, type);
          }
        });
      } else {
        let ObjData = {
          reason: statusType,
          status: statusType,
          userId: timesheetCtreatedUserId,
          timesheet: [rowData.id],
          billableTimesheet: [],
        };
        dataObj.push(ObjData);
        updateBillableActivity(dataObj, type);
      }
    }
    if (type === 2) {
      const lhEntries = empReviewTimesheetList?.filter(timesheet =>
        timesheet?.timesheetProjects.some(detail => detail?.categories?.code === "LH")
      ).map(ts => ({
        date: ts.date,
        id: ts.id
      }));
      console.log(lhEntries, "lhEntrieslhEntrieslhEntries")
      if (lhEntries?.length > 0) {
        setImapctBillableDialog(true);
      } else {
        updateBillableActivity("", type);
      }

    }
  }
  /* Approved Review Timesheet Data End */

  /* Review Data Start */
  const reviewTeamTimesheetDialog = (rowData) => {
    setCurrentReviewRow(rowData);
    setReviewTimesheetDialog(true);
  }

  const viewAllTeamTimesheetDialog = () => {
    let reviewAllTimesheetList = [];
    empReviewTimesheetList.map((el) => {
      el.timesheetProjects.map((item) => {
        reviewAllTimesheetList.push(item);
        return reviewAllTimesheetList;
      });
    });
    setViewAllTimesheet(reviewAllTimesheetList);
    setViewAllTimesheetDialog(true);
  }

  const holiListBodyTemplate = (rowData) => {
    return <p>{rowData.holidayName ? rowData.holidayName : 'N/A'}</p>
  }

  const projectListBodyTemplate = (rowData) => {
    let proName = [];
    rowData.timesheetProjects.map((el) => {
      proName.push(el.projectDetails.title);
    });
    let proNameUnique = Array.from(new Set(proName));
    return <p>{proNameUnique.join(", ")}</p>;
  };

  const projectBodyTemplate = (rowData) => {
    return rowData.projectDetails ? rowData.projectDetails.title : "";
  };

  const categoryBodyTemplate = (rowData) => {
    return rowData.categories ? rowData.categories.title : "";
  }

  const activityBodyTemplate = (rowData) => {
    return rowData.activities ? rowData.activities.title : "";
  }

  const ChargeableOrNot = (el) => {
    return el?.isBillable ? <span style={{ color: 'green', textAlign: 'center' }}>Chargeable</span> : <span style={{ color: 'red', textAlign: 'center' }}>Non Chargeable</span>;
  };

  const rowClassPopup = (rowData) => {
    return {
      'row-accessories': rowData.holidayName
    }
  }

  const hoursRoundOff = (item) => {
    return item.totalHours?.toFixed(2);
  };

  const hoursRoundOffTemplate = (item) => {
    return item.hours?.toFixed(2);
  };

  const ViewAllTimesheetTemplate = () => {
    return (
      <div className="orders-subtable">
        <Dialog className="review-timesheet-pop-up-dialog custom_popup" header="Review All Timesheet" visible={viewAllTimesheetDialog} onHide={() => setViewAllTimesheetDialog(false)} >
          <Fieldset>
            <DataTable columnResizeMode="fit" stripedRows value={viewAllTimesheet} responsiveLayout="scroll">
              <Column field="id" header="ID" style={{ minWidth: "5rem" }}></Column>
              <Column field="date" header="Date" style={{ minWidth: "7rem" }}></Column>
              <Column field="" header="Project" body={projectBodyTemplate} style={{ minWidth: "15rem" }}></Column>
              <Column field="categoryId" header="Category" style={{ minWidth: "10rem" }} body={categoryBodyTemplate}></Column>
              <Column field="activityId" header="Activity" style={{ minWidth: "10rem" }} body={activityBodyTemplate}></Column>
              <Column header="Billing Type" body={ChargeableOrNot} style={{ minWidth: "10rem" }}></Column>
              <Column field="" header="Hours" body={hoursRoundOffTemplate}></Column>
              <Column field="jiraTaskId" header="JIRA / Task ID" style={{ minWidth: "10rem" }}></Column>
              <Column field="description" header="Description" style={{ minWidth: "13rem" }}></Column>
            </DataTable>
          </Fieldset>
        </Dialog>
      </div>
    );
  };

  const ReviewedTimesheetViewTemplate = () => {
    return (
      <div className="orders-subtable">
        <Dialog className="review-timesheet-pop-up-dialog custom_popup" header={"Review Timesheet (" + currentReviewRow?.date + ")"} visible={reviewTimesheetDialog} onHide={() => setReviewTimesheetDialog(false)} >
          <Fieldset>
            <DataTable columnResizeMode="fit" scrollable="horizontal" stripedRows value={currentReviewRow?.timesheetProjects} responsiveLayout="scroll">
              <Column field="id" header="ID" style={{ minWidth: "5rem" }}></Column>
              <Column field="" header="Project" body={projectBodyTemplate} style={{ minWidth: "15rem" }}></Column>
              <Column field="categoryId" header="Category" style={{ minWidth: "10rem" }} body={categoryBodyTemplate}></Column>
              <Column field="activityId" header="Activity" style={{ minWidth: "10rem" }} body={activityBodyTemplate}></Column>
              <Column header="Billing Type" body={ChargeableOrNot} style={{ minWidth: "10rem" }}></Column>
              <Column field="" header="Hours" body={hoursRoundOffTemplate}></Column>
              <Column field="jiraTaskId" header="JIRA / Task ID" style={{ minWidth: "10rem" }}></Column>
              <Column field="description" header="Description" style={{ minWidth: "13rem" }}></Column>
            </DataTable>
          </Fieldset>
        </Dialog>
      </div>
    );
  };
  /* Review Data End */

  const teamActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-times" type="button" className="p-button-rounded p-button-danger mr-2" aria-label="Cancel" tooltip="Reject Timesheet" tooltipOptions={{ position: "top" }} onClick={() => rejectReviewTeamTimesheetData(rowData, 1)} />
        <Button icon="pi pi-check" type="button" className="p-button-rounded mr-2" aria-label="Submit" tooltip="Approve Timesheet" tooltipOptions={{ position: "top" }} onClick={() => approveReviewTeamTimesheetData(rowData, 1)} />
        <Button icon="pi pi-eye" type="button" className="p-button-rounded p-button-secondary" aria-label="View" tooltip="View Timesheet" tooltipOptions={{ position: "top" }} onClick={() => reviewTeamTimesheetDialog(rowData)} />
      </React.Fragment>
    );
  };

  const viewAllTemplate = () => {
    return (
      <React.Fragment>
        <Button type="button" className="p-button-rounded" style={{ height: "35px" }} label="View All" onClick={() => viewAllTeamTimesheetDialog()} />
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className="datatable-style-demo">
        <DataTable dataKey="id" paginator responsiveLayout="scroll" columnResizeMode="fit" scrollable="horizontal"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]} stripedRows ref={dt} value={empReviewTimesheetList} style={{ width: "100%" }} rowClassName={rowClassPopup}>
          <Column field="id" header="ID" style={{ minWidth: "8rem" }}></Column>
          <Column field="date" header="Date" style={{ minWidth: "10rem" }}></Column>
          <Column field="" header="Projects" style={{ minWidth: "10rem" }} body={projectListBodyTemplate}></Column>
          <Column field="" header="Total Hours" body={hoursRoundOff} style={{ minWidth: "8rem" }}></Column>
          <Column field="" header="Holiday" style={{ minWidth: "10rem" }} body={holiListBodyTemplate}></Column>
          <Column field="" header="Action" body={teamActionBodyTemplate} style={{ minWidth: "12rem" }}></Column>
          <Column field="" header={viewAllTemplate} style={{ minWidth: "8rem" }}></Column>
        </DataTable>
      </div>
      {ViewAllTimesheetTemplate()}
      {ReviewedTimesheetViewTemplate()}
      {RejectReviewTimesheetDialog()}
      <div className="formgrid grid mt-4">
        <div className="field col-4" style={{ paddingLeft: "5px" }}>
          <div className="formgrid grid">
            <div className="field mr-2">
              <Button label="Approve All" type="button" className="p-button-rounded" onClick={() => approveReviewTeamTimesheetData("", 2)} disabled={empReviewTimesheetDisabled} />
            </div>
            <div className="field">
              <Button label="Reject All" type="button" className="p-button-rounded p-button-danger" onClick={() => rejectReviewTeamTimesheetData("", 2)} disabled={empReviewTimesheetDisabled} />
            </div>
          </div>
        </div>
      </div>
      {BillableImpactDialog()}
    </React.Fragment>
  );
};

export default ReviewTeamTimesheet;